import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Project_Entity } from "../../entities/project";
import { filmsApi } from "../api/filmsApi";

const projectsAdapter = createEntityAdapter<Project_Entity>();
const initialState = projectsAdapter.getInitialState();

export const projectEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getProjects: build.query<EntityState<Project_Entity>, void>({
      query: () => `projects`,
      transformResponse: (responseData: Project_Entity[]) => {
        return projectsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["projects"],
    }),
    getProject: build.query<Project_Entity, number>({
      query: (id) => `projects/${id}`,
      providesTags: (result, error, id) => [{ type: "projects", id }],
    }),
    createProject: build.mutation<Project_Entity, Partial<Project_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `projects`,
      }),
      invalidatesTags: ["projects"],
    }),
    updateProject: build.mutation<
      void,
      { id: number; body: Partial<Project_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `projects/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "projects", id },
        "projects",
      ],
    }),
    deleteProject: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `projects/${id}`,
      }),
      invalidatesTags: ["projects"],
    }),
  }),
});

export const {
  useGetProjectQuery,
  useGetProjectsQuery,
  useCreateProjectMutation,
  useDeleteProjectMutation,
  useUpdateProjectMutation,
} = projectEndpoints;

export default projectEndpoints;
